import React, { ReactNode } from 'react'
import { StyledHeader } from './styled'

interface IHeaderTemplate {
  logo: ReactNode
  search: ReactNode
  actionPrimary: ReactNode
  actionSecondary?: any
}

export const HeaderTemplate = ({
  logo,
  search,
  actionPrimary,
}: IHeaderTemplate) => (
  <StyledHeader>
    <div className="logo">{logo}</div>
    <div className="back" />
    <div className="search">{search}</div>
    <div className="action-primary">{actionPrimary}</div>
    <div className="action-secondary" />
  </StyledHeader>
)
